import { Card, Col, Row, Space, Tree, Typography } from 'antd'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import EventTag from './EventTag'
import SlotTypeTag from './SlotTypeTag'
import { SlotStateTag, BoxStateTag } from './StateTag'
import { get } from '../../Common/api'

const { Title } = Typography

function buildTagTreeData (tags) {
  const hierarchy = {}
  tags.forEach((tag) => {
    const businessAreaId = tag.family.business_area.id
    const familyId = tag.family.id
    if (!hierarchy[businessAreaId]) {
      hierarchy[businessAreaId] = {
        businessArea: tag.family.business_area,
        families: {}
      }
    }
    if (!hierarchy[businessAreaId].families[familyId]) {
      hierarchy[businessAreaId].families[familyId] = {
        family: tag.family,
        tags: []
      }
    }
    hierarchy[businessAreaId].families[familyId].tags.push(tag)
  })

  return Object.values(hierarchy)
    .sort((a, b) => t(`Admin.Tag.businessArea.${a.businessArea.name}`).localeCompare(t(`Admin.Tag.businessArea.${b.businessArea.name}`)))
    .map((ba) => ({
      key: `ba-${ba.businessArea.id}`,
      title: <EventTag tag={ba.businessArea} type='businessArea' />,
      children: Object.values(ba.families)
        .sort((a, b) => t(`Admin.Tag.family.${a.family.name}`).localeCompare(t(`Admin.Tag.family.${b.family.name}`)))
        .map((fam) => ({
          key: `fam-${fam.family.id}`,
          title: <EventTag tag={fam.family} type='family' />,
          children: fam.tags
            .sort((a, b) => t(`Admin.Tag.${a.name}`).localeCompare(t(`Admin.Tag.${b.name}`)))
            .map((tag) => ({
              key: `tag-${tag.id}`,
              title: <EventTag tag={tag} type='tag' />
            }))
        }))
    }))
}

const SLOT_TYPES = ['CleaningSlot', 'MaintenanceSlot', 'PatientSlot']

const SLOT_STATES = [
  'auto_cancel',
  'cancel',
  'clean_in_progress',
  'done',
  'in_progress',
  'late',
  'not_confirmed',
  'person_left',
  'problem',
  'waiting'
]

const BOX_STATES = [
  'busy',
  'busy_calm_err',
  'busy_open_err',
  'cleaning',
  'cleaning_move_err',
  'cleaning_no_watt_err',
  'empty_busy_2_err',
  'empty_busy_err',
  'empty_clean',
  'empty_no_closed_err',
  'empty_open_err',
  'empty_to_clean',
  'maintenance',
  'stopped',
  'to_clean_open_err',
  'unknow'
]

export default function TagsPage () {
  const [eventTags, setEventTags] = useState([])

  useEffect(() => {
    get({
      url: 'admin/tags',
      params: {},
      onSuccess: (json) => {
        setEventTags(json.tags)
      }
    })
  }, [])

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <Card>
          <Title level={4}>{t('Admin.TagsPage.slot_type')}</Title>
          <Space wrap>
            {SLOT_TYPES.map((type) => (
              <SlotTypeTag key={type} type={type} />
            ))}
          </Space>
        </Card>
      </Col>
      <Col span={24}>
        <Card>
          <Title level={4}>{t('Admin.TagsPage.slot_state')}</Title>
          <Space wrap>
            {SLOT_STATES.map((state) => (
              <SlotStateTag key={state} state={state} />
            ))}
          </Space>
        </Card>
      </Col>
      <Col span={24}>
        <Card>
          <Title level={4}>{t('Admin.TagsPage.box_state')}</Title>
          <Space wrap>
            {BOX_STATES.map((state) => (
              <BoxStateTag key={state} state={state} />
            ))}
          </Space>
        </Card>
      </Col>
      <Col span={24}>
        <Card>
          <Title level={4}>{t('Admin.TagsPage.event_tags')}</Title>
          {eventTags.length > 0 && (
            <Tree
              treeData={buildTagTreeData(eventTags)}
              defaultExpandAll
              selectable={false}
            />
          )}
        </Card>
      </Col>
    </Row>
  )
}
